<template>
  <li v-if="item.directory" class="tree-node">
    <div :class="{selected: selected}" @contextmenu.prevent="rightClick">
      <i :class="{open}" class="icon-angle-right" @click="toggle" />
      <span @click="select"><i class="icon" /> {{ item.name }}</span>
    </div>

    <transition name="fade">
      <ul v-show="open" v-if="item.directory">
        <tree-node v-for="i in item.children" :key="i.name"
                   :item="i"
                   :toggle-handler="toggleHandler"
                   :select-handler="selectHandler"
        />
      </ul>
    </transition>

    <context-menu ref="contextMenu">
      <li v-if="item.path!==currentDirectory" @click="select">{{ $t('g-fileExplorer:open') | capitalize }}</li>
      <li v-if="item.path===currentDirectory" @click="eventBus.$emit('fileExplorer:refresh')">{{ $t('g-fileExplorer:refresh') | capitalize }}</li>
      <li @click="eventBus.$emit('fileExplorer:copy', {element: item})">{{ $t('g-fileExplorer:copy') | capitalize }}</li>
      <li @click="eventBus.$emit('fileExplorer:cut', {element: item})">{{ $t('g-fileExplorer:cut') | capitalize }}</li>
      <li v-if="!isEmpty(clipboard)" @click="eventBus.$emit('fileExplorer:paste', {directory: item})">{{ $t('g-fileExplorer:paste') | capitalize }}</li>
      <li @click="eventBus.$emit('fileExplorer:delete', {element: item})">{{ $t('g-fileExplorer:delete') | capitalize }}</li>
    </context-menu>
  </li>
</template>

<script>
import { isEmpty } from 'lodash-es'
import { mapGetters } from 'vuex'
import eventBus from '@/modules/eventBus'

export default {
  name: 'TreeNode',

  props: {
    // Tree node
    item: {
      type: Object,
      required: true
    },
    // Default open status
    openDefault: {
      type: Boolean,
      default: false
    },
    // Toggle handler
    toggleHandler: {
      type: Function,
      default: () => {}
    },
    // Select handler
    selectHandler: {
      type: Function,
      default: () => {}
    }
  },

  data () {
    return {
      open: false,
      selected: false,
      evtBus: null
    }
  },

  computed: {
    isEmpty () { return isEmpty },
    ...mapGetters(['clipboard', 'currentDirectory']),
    eventBus () { return eventBus }
  },

  created () {
    // Set default values
    this.open = this.openDefault
    // Using a empty Vue instance as event bus
    // We cannot use a store/props with a watch, it does not work when using the same key several times
    eventBus.$on('fileExplorer:unselect', this.unselect)
  },

  destroyed () {
    eventBus.$off('fileExplorer:unselect', this.unselect)
  },

  methods: {
    // Context menu event on right click
    rightClick (event) {
      // Open context menu
      this.$refs.contextMenu.open(event)
    },

    toggle () {
      this.open = !this.open

      // Call toggle handler, only if openning
      if (this.open) {
        if (typeof this.toggleHandler === 'function') this.toggleHandler(this.item)
      }
    },

    select () {
      // If not selected, select it
      if (!this.selected) {
        // Clear all selected
        eventBus.$emit('fileExplorer:unselect')

        // Reset selected item as we are openning a folder
        this.$store.commit('setSelectedElement', null)

        // Select clicked item
        this.selected = true
      }

      // Call select handler
      if (typeof this.selectHandler === 'function') this.selectHandler(this.item)
    },

    unselect () {
      this.selected = false
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  li.tree-node {
    user-select: none;

    & > div {
      &.selected {
        font-weight: bold;
      }

      .icon-angle-right {
        display: inline-block;
        cursor: pointer;
        transition: all 0.35s ease;

        &.open {
          transform: rotate(90deg);
        }
      }

      span {
        font-size: 12px;
        color: $primary;
        cursor: pointer;

        i.icon {
          display: inline-block;
          width: 21px;
          height: 21px;
          padding: 0;
          margin: 0;
          line-height: 0;
          vertical-align: bottom;
          background-color: transparent;
          background-image: url("~@/img/file-explorer.png");
          background-repeat: no-repeat;
          background-attachment: scroll;
          background-position: -147px 0;
          border: 0 none;
          outline: none;
        }
      }
    }

    ul {
      padding: 0 0 0 15px;
      margin: 0;
      list-style: none;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.35s;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }
</style>
